/*hg-treck-res*/
		$isResizeble = false;
		$new_mhs = false;
/*hg-treck-res*/
/*hg-norm-adpt*/
	$(window).on('load resize', function(){
	  if ($(window).width() > 1000 ) {
	/*ll-hg-pc bg*/
	        $(window).scroll(function(e){
	          var scroll = $(window).scrollTop();
	          $wh = $(window).height();

	         $('.hg-ll-img').each(function() {
	          $lod_i = $(this).attr('data-p-i');
	        $cprod_t = $(this).offset().top/ 2;
	        if(scroll + $wh > $cprod_t){
	          if ($(this).is('[style="background-image"]')){ }else {
	          $(this).css('background-image','url('+$lod_i+')');
	          }
	        }
	        });
	      });


	         $('.imgll-hg').each(function() {
	        $lod_ii = $(this).attr('data-src-pc');
	          if ($(this).is('[src]')){ }else {
	          $(this).attr('src',$lod_ii);
	          }
	        });

	/*ll-hg-pc bg*/
	/*hov-prod*/
	$(".hg-prod").hover(function () {
	    var sourceFile = $(this).find(".prod_bg_img_h").attr("data_h");
	    if ($(this).find(".prod_bg_img_h").is('[style="background-image"]')) {
	    }else{
	    $(this).find(".prod_bg_img_h").css('background-image', 'url('+sourceFile+')');
	    };
	    }, function () {
	 });
	/*hov-prod*/
	   } else {
	/*ll-hg-mob bg*/
	$rou_wh_w = $(window).height();
	$rou_wh_s = screen.availHeight;
	$rou_wh_n = ($rou_wh_s  - $rou_wh_w) /3;
	$rou_wh = $rou_wh_s - $rou_wh_n;
	$('head').append('<style>html body:after,html body:before{height:'+$rou_wh+'px}</style>');




	         $('.imgll-hg').each(function() {
	        $lod_ii = $(this).attr('data-src-m');
	        $cprod_ti = $(this).offset().top;

	          if ($(this).is('[src]')){ }else {
	          $(this).attr('src',$lod_ii);

	        }
	        });


	        $(window).scroll(function(e){
	          var scroll = $(window).scrollTop();
	          $wh = $(window).height();

	          $('.hg-ll-img').each(function() {

	        $cprod_t = $(this).offset().top;
	        if(scroll + $wh > $cprod_t){
	        if ($(window).width() > 1000 ) {
	          	$lod_i = $(this).attr('data-p-i');
	      	}else{
	      	  	$lod_i = $(this).attr('data-m-i');
	      	}


	          if ($(this).is('[style="background-image"]')){ }else {
	          $(this).css('background-image','url('+$lod_i+')');
	          }
	        }
	        });
	      });
	/*ll-hg-mob bg*/
		if(!$isResizeble) {
		}
	}
	});
/*hg-norm-adpt*/
$( document ).ready(function() {

	        $('.hg-sp-pc').each(function() {
	          if ($(window).width() > 1000 ) {
	          	$lod_i = $(this).attr('data-p-i');
	          	$(this).attr('src',''+$lod_i+'');
	      	  }

	        });



	        $('.hg-ll-img-st').each(function() {
	          if ($(window).width() > 1000 ) {
	          	$lod_i = $(this).attr('data-p-i');
	      	  }else{
	      	  	$lod_i = $(this).attr('data-m-i');
	      	  }
	          if ($(this).is('[style="background-image"]') && $lod_i){ }else {
	          $(this).css('background-image','url('+$lod_i+')');
	          }
	        });
	       	$('.hg-ll-img-st-sl').each(function() {
	          if ($(window).width() > 1000 ) {
	          	$lod_i = $(this).attr('data-p-i');
	      	  }else{
	      	  	$lod_i = $(this).attr('data-p-i');
	      	  }
	          if ($(this).attr('data-flickity-bg-lazyload') == ''){
	          $(this).attr('data-flickity-bg-lazyload',$lod_i);
	          }
	        });

	  	var doAnimations = function() {
	    var offset = $(window).scrollTop() + window.innerHeight,
	        $animatables = $('.animatable');
	    if ($animatables.length == 0) {
	      $(window).off('scroll', doAnimations);
	    }

	    $animatables.each(function(i) {
	       var $animatable = $(this);
	         if ($(window).width() < 960) {
	          var $scrollstep = 150;
	         }else{
	          var $scrollstep = 200;
	         };
	      if (($animatable.offset().top  + $scrollstep) < offset) {
	        $animatable.removeClass('animatable').addClass('animated');
	      }
	    });
	  };
	  $(window).on('scroll', doAnimations);
	  $(window).trigger('scroll');



$('.hg-ll-video').each(function(index) {
	$pc_v = $(this).attr('data-v-pc');
	$m_v = $(this).attr('data-v-m');
	if ($(window).width() > 1023) {

				$(this).find('source').attr('src', $pc_v);
				$(this).trigger('load');
				//$(this).trigger('play');

		}else{

				$(this).find('source').attr('src', $m_v);
				$(this).trigger('load');
				//$(this).trigger('play');

	}
});
});



$(function() {
  var $vid   = $('.hg-ll-video');
  var $srcEl = $vid.find('source');

  function loadAndPlay() {
    if (!$srcEl.attr('src')) {
      $srcEl.attr('src', $srcEl.data('src'));
      $vid[0].load();        // запускаємо завантаження
      if ($vid.prop('autoplay')) {
        // спробуємо запустити відтворення; якщо не вийде — виставимо muted
        $vid[0].play().catch(function() {
          $vid.prop('muted', true);
          $vid[0].play();
        });
      }
    }
  }

  if ($vid.prop('autoplay')) {
    // для autoplay — одразу після DOM готовності
    loadAndPlay();
  } else {
    // без autoplay — при першому кліці Play
    $vid.one('play', loadAndPlay);
  }
});

document.addEventListener('shopify:section:load', function(e) {
  var $section = $(e.target);

  // images
  $section.find('.hg-ll-img-st').each(function() {
    var $el = $(this);
    var src = $(window).width() > 1023 ? $el.attr('data-p-i') : ($el.attr('data-m-i') || $el.attr('data-p-i'));
    if (src) $el.css('background-image', 'url(' + src + ')');
  });

  $section.find('.hg-ll-img').each(function() {
    var $el = $(this);
    var src = $(window).width() > 1023 ? $el.attr('data-p-i') : ($el.attr('data-m-i') || $el.attr('data-p-i'));
    if (src) $el.css('background-image', 'url(' + src + ')');
  });

  $section.find('.imgll-hg').each(function() {
    var $el = $(this);
    var src = $(window).width() > 1023 ? $el.attr('data-src-pc') : ($el.attr('data-src-mob') || $el.attr('data-src-pc'));
    if (src && !$el.attr('src')) $el.attr('src', src);
  });

  // videos
  $section.find('.hg-ll-video').each(function() {
    var $vid = $(this);
    var src = $(window).width() > 1023 ? $vid.attr('data-v-pc') : ($vid.attr('data-v-m') || $vid.attr('data-v-pc'));
    if (src) {
      $vid.find('source').attr('src', src);
      this.load();
    }
  });

  // animations
  $section.find('.animatable').removeClass('animatable').addClass('animated');
});
